<template>
  <div class="wine-details" data-medusa data-medusa-animation="wine-details">
    <div
      class="wine-details__image"
      ref="floating"
      :style="{ backgroundImage: `url('/static/bottles/${content[$route.params.bottle] || 'cuvee-1821'}/label.jpg')` }"
    ></div>
    <div class="wine-details__content">
      <div
        class="wine-details__title"
        data-in-out
        data-in-out-animation="slide"
      >
        <h2 v-html="title"></h2>
      </div>
      <div
        class="wine-details__text"
        data-in-out
        data-in-out-animation="slide"
        v-html="text"
      ></div>

      <div class="wine-details__grid">
        <div
          class="wine-details__detail"
          data-in-out
          data-in-out-animation="slide"
          v-for="(detail, index) in details"
          :key="index"
        >
          <div class="wine-details__detail-title">
            <span>{{ detail.title }}</span>
          </div>
          <div class="wine-details__detail-text" v-html="detail.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TweenMax from 'gsap/TweenMaxBase';
import engine from '../../scripts/engine';

export default {
  name: 'WineDetails',

  props: ['data'],

  data() {
    return {
      content: {
        'cuvee-1821': 'cuvee-1821',
        'prestige-1821': 'prestige-1821',
        'black-cuvee': 'black-edition',
        'white-cuvee': 'white-edition',
        'grey-cuvee': 'grey-edition',
        'special-cuvee-millesimato': 'special-cuvee',
        'spumante-brut': 'extra-dry',
        'platinum-label-en': 'spumante-brut',
      },
    };
  },

  computed: {
    title() {
      return this.data['text-block'].column[0].title;
    },

    text() {
      return this.data['text-block'].column[0].text;
    },

    details() {
      return this.data['details-grid'].column;
    },
  },

  mounted() {
    this.$nextTick(() => {
      engine.add(() => {
        const image = this.$refs.floating;
        const center = window.innerHeight / 2;
        const fromCenter = (image.getBoundingClientRect().top + image.getBoundingClientRect().height / 4) - center;
        TweenMax.set(image, { y: fromCenter * 0.4, rotation: fromCenter * 0.01 });
      }, 'wine-details-scroll');
    });
  },

  beforeDestroy() {
    engine.remove('wine-details-scroll');
  },
};
</script>

<style lang="scss">
.wine-details {
  position: relative;
  margin-top: calc((100vh / 18) * 5);

  @include mq($until: ipadL) {
    margin-top: calc((100vh / 18) * 2);
  }

  &__image {
    position: absolute;
    width: calc(956px * var(--rw));
    height: calc(1080px * var(--rw));
    top: calc(-200px * var(--rw));
    right: calc((100vw / 32) * 8);
    background-image: url('/static/img/02.png');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  &__content {
    position: relative;
    z-index: 2;
  }

  &__title h2 {
    font-size: rem(150px);
    font-size: calc(150px * var(--rw));
    line-height: 1;
    font-weight: 400;
    margin-bottom: calc((100vh / 18) * 3);

    @include mq($until: ipadL) {
      font-size: rem(60px);
      font-size: calc(60px * var(--rw));
      margin-bottom: calc((100vh / 18) * 1);
    }
  }

  &__text {
    width: calc((100vw / 32) * 8);
    color: $color-white;

    @include mq($until: ipadL) {
      width: calc(100% - ((100vw / 32) * 8));
    }
  }

  &__text p {
    font-weight: 300;
    font-size: rem(22px);
    font-size: calc(22px * var(--rw));
    line-height: rem(40px);
    line-height: calc(40px * var(--rw));
  }

  &__grid {
    width: calc((100vw / 32) * 21);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: calc((100vw / 32) * 2);
    grid-row-gap: calc((100vh / 18) * 2);
    margin-top: calc((100vh / 18) * 4);
    color: $color-white;

    @include mq($until: ipadL) {
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: repeat(4, 1fr);
      grid-row-gap: calc((100vh / 18) * 1);
      margin-top: calc((100vh / 18) * 2);
    }
  }

  &__detail {
    &-title {
      color: $color-primary;
      font-family: 'IGT Frankling Gothic';
      text-transform: uppercase;
      font-weight: bold;
      font-size: rem(22px);
      font-size: $font-size-text;
      margin-bottom: calc((100vh / 18) * 1);

      @include mq($until: ipadL) {
        margin-bottom: calc((100vh / 18) * 0.25);
      }
    }

    &-text p {
      font-weight: 300;
      font-size: rem(22px);
      font-size: calc(22px * var(--rw));
      line-height: rem(40px);
      line-height: calc(40px * var(--rw));
    }
  }
}
</style>
